<template>
  <div class="d-flex justify-content-center align-items-center flex-column" style="height: 80vh;">
    此頁面不存在，請點擊下方按鈕回到首頁
    <button
      type="button"
      class="btn btn-outline-primary mt-2"
      @click="goHome"
    >返回首頁</button>
  </div>
</template>
<script>
export default {
  methods: {
    async goHome() {
      this.$router.push("/");
    }
  }
};
</script>